import data from "../../../locale/data/es";

/* step name each question is used to identify questions and to send
   data to backend
*/
export const stepNames = {
  AGE: "Age",
  GENDER: "Gender",
  PREGNANCY: "Pregnancy",
  VERTERAN: "VETERAN STATUS",
  INSURANCE: "Insurance",
  MENTAL_HEALTH: "MentalHealth",
  DRUG_USE: "DrugUse",
  DRUG_CONSUMPTION: "DrugConsumption",
  TRANSPORTATION: "TransportationAssistance"
};

export const ageAnswers = {
  // YES: "Yes",
  // NO: "No",
  YES: "view.quickSearchQuestions.q1.yes",
  NO: "view.quickSearchQuestions.q1.no",
};

export const genderAnswers = {
  FEMALE: "view.quickSearchQuestions.q2.female",
  MALE: "view.quickSearchQuestions.q2.male",
  OTHER: "view.quickSearchQuestions.q2.other",
};

export const pregnancyAnswers = {
  YES: "view.quickSearchQuestions.q3.yes",
  NO: "view.quickSearchQuestions.q3.no",
};

export const insuranceAnswers = {
  NO_INSURANCE: "view.quickSearchQuestions.q5.noinsurance",
  MEDICARE: "view.quickSearchQuestions.q5.medicare",
  MEDICAID: "view.quickSearchQuestions.q5.medicaid",
  PRIVATE_INSURANCE: "view.quickSearchQuestions.q5.privateinsurance",
  VA_INSURANCE: "view.quickSearchQuestions.q5.vainsurance",
  COURT_ORDERED: "view.quickSearchQuestions.q5.courtordered",
  I_DONT_KNOW: "view.quickSearchQuestions.q5.idontknow",
};

const mentalHealthAnswers = {
  ANXIETY: "view.quickSearchQuestions.q6.anxietydepression",
  // DEPRESSION: "Depression",
  BIPOLAR_DISORDER: "view.quickSearchQuestions.q6.bipolardisorder",
  PERSONALITY_DISRODER: "view.quickSearchQuestions.q6.personalitydisorders",
  OCD: "view.quickSearchQuestions.q6.obsessivecompulsivedisorderocd",
  SCHIZOPHRENIA: "view.quickSearchQuestions.q6.schizophrenia",
  EATING_DISORDER: "view.quickSearchQuestions.q6.eatingdisorders",
  PTSD: "view.quickSearchQuestions.q6.ptsd",
  ADHD: "view.quickSearchQuestions.q6.adhd",
  NONE_OF_THESE: "view.quickSearchQuestions.q6.noneidontknow",
  // OTHER: "Other/I'm not sure",
};

const drugUseAnswers = {
  OPIOIDS:
    "view.quickSearchQuestions.q7.heroinpainpillsfentanylandorotheropioids",
  ALCOHOL: "view.quickSearchQuestions.q7.alcohol",
  // METH: "Meth",
  BENZOS: "view.quickSearchQuestions.q7.benzosvaliumxanaxativan",
  MARIJUANA: "view.quickSearchQuestions.q7.marijuana",
  COCAINE: "view.quickSearchQuestions.q7.cocaineandormeth",
  OTHER: "view.quickSearchQuestions.q7.otheridontknow",
};

// const drugConsumptionAnswers = {
//   SNORT: "Snort",
//   SMOKE: "Smoke",
//   NEEDLE: "Needle",
//   SWALLOW: "Swallow",
//   DONT_KNOW: "Don't know",
// };

export const transportationAssistance = {
  YES: "view.quickSearchQuestions.q8.yes",
  NO: "view.quickSearchQuestions.q8.no",
}

export const veteranAnswers = {
  YES: "view.quickSearchQuestions.q4.yes",
  NO : "view.quickSearchQuestions.q4.no",
  FAMILY : "view.quickSearchQuestions.q4.familymemberofaveteranmilitaryservicemember",
  OTHER: "view.quickSearchQuestions.q4.idontknow"
}
/*
  if answer is not compound, isCompound will be false and filters will only have filter key
  if answer is compound, isCompund will be true and there will be 'andOp' and 'orOp'
*/
export const getQuestions = () => {
  const questions = [
    {
      step: stepNames.AGE,
      questionText: "view.quickSearchQuestions.q1.question",
      answerOptions: [
        {
          id: 0,
          answerText: ageAnswers.YES,
          filters: {
            isCompound: false,
            filter: null,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 1,
          answerText: ageAnswers.NO,
          filters: {
            isCompound: true,
            //andOp: [43,44],
            andOp: [],
            orOp: [43, 44],
          },
          selected:false,
          question_id:null,
        },
      ],
      isMultiSelect: false,
      isAnswered: false,
    },
    {
      step: stepNames.GENDER,
      questionText: "view.quickSearchQuestions.q2.question",
      answerOptions: [
        {
          id: 0,
          answerText: genderAnswers.FEMALE,
          filters: {
            isCompound: true,
            //andOp: [38,145],
            andOp: [],
            orOp: [38, 145],
          },
          selected:false,
          question_id:null,
        },
        {
          id: 1,
          answerText: genderAnswers.MALE,
          filters: {
            isCompound: true,
            //andOp: [37,145],
            andOp: [],
            orOp: [37, 145],
          },
          selected:false,
          question_id:null,
        },
        {
          id: 2,
          answerText: genderAnswers.OTHER,
          filters: {
            isCompound: true,
            andOp: [54, 145],
            orOp: [],
          },
          selected:false,
          question_id:null,
        },
      ],
      isMultiSelect: false,
      isAnswered: false,
      skipPregnancyInquiry: false,
    },
    {
      step: stepNames.PREGNANCY,
      questionText: "view.quickSearchQuestions.q3.question",
      answerOptions: [
        {
          id: 0,
          answerText: pregnancyAnswers.YES,
          filters: {
            isCompound: false,
            filter: 39,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 1,
          answerText: pregnancyAnswers.NO,
          filters: {
            isCompound: false,
            filter: null,
          },
          selected:false,
          question_id:null,
        },
      ],
      isMultiSelect: false,
      isAnswered: false,
      isPregAnswered: false,
      stopPregnancyInquiry: false,
    },
    {
      step: stepNames.VERTERAN,
      questionText: "view.quickSearchQuestions.q4.question",
      answerOptions : [
        {
          id: 0,
          answerText: veteranAnswers.YES,
          filters: {
            isCompound: false,
            filter: null,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 1,
          answerText: veteranAnswers.NO,
          filters: {
            isCompound: false,
            filter: null,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 2,
          answerText: veteranAnswers.FAMILY,
          filters: {
            isCompound: false,
            filter: null,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 3,
          answerText: veteranAnswers.OTHER,
          filters: {
            isCompound: false,
            filter: null,
          },
          selected:false,
          question_id:null,
        },
      ],
      isMultiSelect: false,
      isAnswered: false,

    },
    {
      step: stepNames.INSURANCE,
      questionText: "view.quickSearchQuestions.q5.question",
      answerOptions: [
        {
          id: 0,
          answerText: insuranceAnswers.NO_INSURANCE,
          filters: {
            isCompound: true,
            andOp: [232, 8],
            orOp: [],
          },
          selected:false,
          question_id:null,
        },
        {
          id: 1,
          answerText: insuranceAnswers.MEDICARE,
          filters: {
            isCompound: false,
            filter: 121,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 2,
          answerText: insuranceAnswers.MEDICAID,
          filters: {
            isCompound: false,
            filter: 120,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 3,
          answerText: insuranceAnswers.PRIVATE_INSURANCE,
          filters: {
            isCompound: false,
            filter: 122,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 4,
          answerText: insuranceAnswers.VA_INSURANCE,
          filters: {
            isCompound: false,
            filter: 119,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 5,
          answerText: insuranceAnswers.COURT_ORDERED,
          filters: {
            isCompound: false,
            filter: 124,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 6,
          answerText: insuranceAnswers.I_DONT_KNOW,
          filters: {
            isCompound: false,
            filter: 60,
          },
          selected:false,
          question_id:null,
        },
      ],
      isMultiSelect: false,
      isAnswered: false,
    },
    {
      step: stepNames.MENTAL_HEALTH,
      questionText: "view.quickSearchQuestions.q6.question",
      answerOptions: [
        {
          id: 0,
          answerText: mentalHealthAnswers.ANXIETY,
          filters: {
            isCompound: false,
            filter: 128,
          },
          selected:false,
          question_id:null,
        },
        // {
        //   id: 1,
        //   answerText: mentalHealthAnswers.DEPRESSION,
        //   filters: {
        //     isCompound: false,
        //     filter: 129,
        //   },
        // },
        {
          id: 1,
          answerText: mentalHealthAnswers.BIPOLAR_DISORDER,
          filters: {
            isCompound: false,
            filter: 130,
            selected:false,
            question_id:null,
          },
        },
        {
          id: 2,
          answerText: mentalHealthAnswers.PERSONALITY_DISRODER,
          filters: {
            isCompound: false,
            filter: 131,
            selected:false,
            question_id:null,
          },
        },
        {
          id: 3,
          answerText: mentalHealthAnswers.OCD,
          filters: {
            isCompound: false,
            filter: 132,
            selected:false,
            question_id:null,
          },
        },
        {
          id: 4,
          answerText: mentalHealthAnswers.SCHIZOPHRENIA,
          filters: {
            isCompound: false,
            filter: 133,
            selected:false,
            question_id:null,
          },
        },
        {
          id: 5,
          answerText: mentalHealthAnswers.EATING_DISORDER,
          filters: {
            isCompound: false,
            filter: 134,
            selected:false,
            question_id:null,
          },
        },
        {
          id: 6,
          answerText: mentalHealthAnswers.PTSD,
          filters: {
            isCompound: false,
            filter: 234,
            selected:false,
            question_id:null,
          },
        },
        {
          id: 7,
          answerText: mentalHealthAnswers.ADHD,
          filters: {
            isCompound: false,
            filter: 235,
            selected:false,
            question_id:null,
          },
        },
        {
          id: 8,
          answerText: mentalHealthAnswers.NONE_OF_THESE,
          filters: {
            isCompound: false,
            filter: [],
            selected:false,
            question_id:null,
          },
        },
        // {
        //   id: 9,
        //   answerText: mentalHealthAnswers.OTHER,
        //   filters: {
        //     isCompound: false,
        //     filter: 129,
        //   },
        // },
      ],
      isMultiSelect: true,
      isAnswered: false,
    },
    {
      step: stepNames.DRUG_USE,
      questionText:
        "view.quickSearchQuestions.q7.question",
      answerOptions: [
        {
          id: 0,
          answerText: drugUseAnswers.OPIOIDS,
          filters: {
            isCompound: true,
            andOp: ["Assessment", "Outpatient", "Intensive Outpatient Program"],
            orOp: ["Inpatient", "Residential"],
          },
          selected:false,
          question_id:null,
        },
        {
          id: 1,
          answerText: drugUseAnswers.ALCOHOL,
          filters: {
            isCompound: true,
            andOp: ["Assessment", "Outpatient", "Intensive Outpatient Program"],
            orOp: ["Inpatient", "Residential"],
          },
          selected:false,
          question_id:null,
        },
        // {
        //   id: 2,
        //   answerText: drugUseAnswers.METH,
        //   filters: {
        //     isCompound: true,
        //     andOp: ["Assessment", "Outpatient"],
        //     orOp: [],
        //   },
        // },
        {
          id: 2,
          answerText: drugUseAnswers.BENZOS,
          filters: {
            isCompound: true,
            andOp: ["Assessment", "Outpatient", "Intensive Outpatient Program"],
            orOp: ["Inpatient", "Residential"],
          },
          selected:false,
          question_id:null,
        },
        {
          id: 3,
          answerText: drugUseAnswers.MARIJUANA,
          filters: {
            isCompound: true,
            andOp: ["Assessment", "Outpatient"],
            orOp: [],
          },
          selected:false,
          question_id:null,
        },
        {
          id: 4,
          answerText: drugUseAnswers.COCAINE,
          filters: {
            isCompound: true,
            andOp: ["Assessment", "Outpatient"],
            orOp: [],
          },
          selected:false,
          question_id:null,
        },
        {
          id: 5,
          answerText: drugUseAnswers.OTHER,
          filters: {
            isCompound: true,
            andOp: ["Assessment", "Outpatient"],
            orOp: [],
          },
          selected:false,
          question_id:null,
        },
      ],
      isMultiSelect: true,
      isAnswered: false,
    },
    // {
    //   step: stepNames.DRUG_CONSUMPTION,
    //   questionText: "How do you use? (You can choose more than one)",
    //   answerOptions: [
    //     {
    //       id: 0,
    //       answerText: drugConsumptionAnswers.SNORT,
    //       filters: {
    //         isCompound: true,
    //         andOp: [
    //           "Assessment",
    //           "Partial Hospitalization",
    //           "Intensive Outpatient Program",
    //         ],
    //         orOp: [],
    //       },
    //     },
    //     {
    //       id: 1,
    //       answerText: drugConsumptionAnswers.SMOKE,
    //       filters: {
    //         isCompound: true,
    //         andOp: [
    //           "Assessment",
    //           "Partial Hospitalization",
    //           "Intensive Outpatient Program",
    //         ],
    //         orOp: [],
    //       },
    //     },
    //     {
    //       id: 2,
    //       answerText: drugConsumptionAnswers.NEEDLE,
    //       filters: {
    //         isCompound: true,
    //         andOp: ["Assessment", "Residential"],
    //         orOp: [],
    //       },
    //     },
    //     {
    //       id: 3,
    //       answerText: drugConsumptionAnswers.SWALLOW,
    //       filters: {
    //         isCompound: true,
    //         andOp: ["Assessment", "Outpatient"],
    //         orOp: [],
    //       },
    //     },
    //     {
    //       id: 4,
    //       answerText: drugConsumptionAnswers.DONT_KNOW,
    //       filters: {
    //         isCompound: true,
    //         andOp: ["Assessment", "Intensive Outpatient Program"],
    //         orOp: [],
    //       },
    //     },
    //   ],
    //   isMultiSelect: true,
    // },
    {
      step: stepNames.TRANSPORTATION,
      questionText: "view.quickSearchQuestions.q8.question",
      answerOptions: [
        {
          id: 0,
          answerText: transportationAssistance.YES,
          filters: {
            isCompound: false,
            filter: 27,
          },
          selected:false,
          question_id:null,
        },
        {
          id: 1,
          answerText: transportationAssistance.NO,
          filters: {
            isCompound: false,
            filter: null,
          },
          selected:false,
          question_id:null,
        }
      ],
      isMultiSelect: false,
      isAnswered: false,
    }
  ];
  return questions;
};
